import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createSlots as _createSlots, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-span-6" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "col-span-6" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = { class: "col-span-6" }
const _hoisted_9 = { class: "col-span-6" }
const _hoisted_10 = { class: "col-span-6" }
const _hoisted_11 = { class: "col-span-6" }
const _hoisted_12 = { class: "col-span-6" }
const _hoisted_13 = { class: "col-span-6" }
const _hoisted_14 = { class: "col-span-6" }

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';

import { useRoute } from 'vue-router';
import { ref, watch, onMounted, computed } from 'vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import BookingService from '@/classes/BookingService';

const timezoneOffset = 8; // Philippines time zone is UTC+8

export default /*@__PURE__*/_defineComponent({
  __name: 'EditSoftFormSection',
  props: {
    isNetworkAvailable: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {

const route = useRoute();

const props = __props;


const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)

// const selectedDate = ref(null)
const selectedTime = ref(null)
const fullyBookedDates = ref([]);
const unformattedTimeSlots = ref([]);
const timeSlots = ref([]);

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth();
const threeDaysLater = new Date(currentDate.getTime() + 3 * 24 * 60 * 60 * 1000 + timezoneOffset * 60 * 60 * 1000); // For 3 days advance booking

const minDate = computed(() => threeDaysLater.toISOString().slice(0, 10));
const from = ref(null);
const to = ref(null);

const selectedDate = ref(minDate.value)

const appointment = ref(null);
const riders = computed(() => {
    let items = '';
    appointment.value.other_charges_line.forEach(element => {
        items += element.item_name ? element.item_name + ', ' : '';
    });
    return items;
});

const payload = ref({
    id: null,
    branch_id: null,
    booking_date: null,
    booking_start_time: null,
    booking_end_time: null,
});

const fetchSoftBooking = () => {
    loader.value = true

    BookingService.fetchSoftBooking(route.params.bookingId)
        .then((result: any) => {
            loader.value = false;
            if(route.query.booking_type == 'Soft' || route.query.booking_type == 'soft') {
                appointment.value = result.data;
            } else {
                appointment.value = result.data.response;
            }

            console.log(appointment.value.branch_id);
            // Fill up payloads
            payload.value.id = appointment.value.id;
            payload.value.branch_id = appointment.value.branch_id;

            selectedDate.value = appointment.value.booking_date;
            if(appointment.value.booking_start_time && appointment.value.booking_end_time) {
                selectedTime.value = `${formatTime(appointment.value.booking_start_time)}-${formatTime(appointment.value.booking_end_time)}`
            }

            fetchDateAndTime();
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error;

            console.log(error)

            if(error.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const formatTime = (time) => {
  const [hours, minutes] = time.split(":");
  const suffix = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // handle midnight (00:00:00) as 12 AM
  return `${formattedHours}:${minutes} ${suffix}`;
};

const updateSoftBooking = () => {

    loader.value = true;


    BookingService.updateSoftBooking(payload.value)
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                showSuccess.value = true;
            }
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const formatTimeSlots = () => {
    timeSlots.value = [];
    for(const unformattedTimeSlot in unformattedTimeSlots.value) {
        unformattedTimeSlots.value[unformattedTimeSlot].forEach(slot => {
            if(slot.available_slots != 0) {
                if(!slot.is_blocked) {
                    timeSlots.value.push(slot);
                }
            }
        });

    }
}

const fetchDateAndTime = () => {
    loader.value = true

    const data = {
        branch_id: payload.value.branch_id,
        selected_date: payload.value.booking_date,
        from: from.value,
        to: to.value,
    }

    BookingService.fetchDateAndTime(data)
        .then((result: any) => {
            loader.value = false;

            fullyBookedDates.value = result.data.response.fully_booked_dates;         
            unformattedTimeSlots.value = result.data.response.time_slots;         
            
            if(selectedDate.value) {
                formatTimeSlots();
            }
        })
        .catch((error) => {
            loader.value = false;
            showError.value = true;
            // errorMsg.value = error;
            errorMsg.value = error.response?.data?.message;

            if(error.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

const updateMonth = (val = null) => {
    // Get First and Last Day for Active Month
    const monthYear = {
        year: currentYear,
        month: currentMonth,
    }

    from.value = firstDayOfMonth(val ? val : monthYear)
    to.value = lastDayOfMonth(val ? val : monthYear);

    // Fetch fetchDateAndTime for Active Month
    if(payload.value.branch_id) {
        fetchDateAndTime();
    }
}

const firstDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-01`;

    return formattedDate;
}

const lastDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const lastDay = new Date(year, month, 0).getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay.toString().padStart(2, '0')}`;

    return formattedDate;    
}

watch(
    () => selectedTime.value,
    (val) => {
        if(val)
        selectTimeSlot(val);
    },
    { immediate: true }
);

const selectTimeSlot = (val) => {
    if(val) {
        payload.value.booking_start_time = val.split('-')[0];
        payload.value.booking_end_time = val.split('-')[1];
    }
}

watch(
    () => selectedDate.value,
    (val) => {
        if(val)
            // selectedTime.value = null;
            payload.value.booking_date = new Date(selectedDate.value).toISOString().split('T')[0];
            updateMonth();
    },
    { immediate: true }
);

onMounted(() => {
    fetchSoftBooking();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (appointment.value)
      ? (_openBlock(), _createBlock(FormSection, { key: 0 }, _createSlots({
          title: _withCtx(() => [
            _cache[21] || (_cache[21] = _createTextVNode(" Booking Information ", -1))
          ]),
          description: _withCtx(() => [
            _cache[22] || (_cache[22] = _createTextVNode(" Relevant data and other details ", -1))
          ]),
          form: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(TextInput, {
                disabled: "",
                label: "First Name",
                placeholder: "First Name",
                modelValue: appointment.value.patient.first_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((appointment.value.patient.first_name) = $event)),
                id: "first_name",
                name: "first_name"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(TextInput, {
                disabled: "",
                label: "Middle Name",
                placeholder: "Middle Name",
                modelValue: appointment.value.patient.middle_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((appointment.value.patient.middle_name) = $event)),
                id: "middle_name",
                name: "middle_name"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(TextInput, {
                disabled: "",
                label: "Last Name",
                placeholder: "Last Name",
                modelValue: appointment.value.patient.last_name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((appointment.value.patient.last_name) = $event)),
                id: "last_name",
                name: "last_name"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(TextInput, {
                disabled: "",
                label: "Patient ID",
                placeholder: "Patient ID",
                modelValue: appointment.value.patient.patient_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((appointment.value.patient.patient_id) = $event)),
                id: "patient_id",
                name: "patient_id"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(TextInput, {
                disabled: "",
                label: "Email Address",
                placeholder: "Email Address",
                modelValue: appointment.value.patient.email_address,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((appointment.value.patient.email_address) = $event)),
                id: "email_address",
                name: "email_address"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(TextInput, {
                disabled: "",
                label: "Branch",
                placeholder: "Branch",
                modelValue: appointment.value.branch.name,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((appointment.value.branch.name) = $event)),
                id: "branch_name",
                name: "branch_name"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(DatePicker, {
                modelValue: selectedDate.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedDate).value = $event)),
                id: "selectedDate",
                name: "selectedDate",
                label: "Booking Date",
                placeholder: "MM/DD/YYYY",
                "min-date": minDate.value,
                "fully-booked-dates": fullyBookedDates.value,
                "hide-offset-dates": "",
                "highlight-disabled-days": "",
                onUpdateMonth: updateMonth,
                disabled: !props.isNetworkAvailable
              }, null, 8, ["modelValue", "min-date", "fully-booked-dates", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(MultiselectInput, {
                modelValue: selectedTime.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedTime).value = $event)),
                id: "selectedTime",
                name: "selectedTime",
                label: "Booking Time",
                placeholder: "Booking Time",
                options: timeSlots.value,
                disabled: !props.isNetworkAvailable
              }, null, 8, ["modelValue", "options", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(TextInput, {
                disabled: "",
                label: "Package",
                placeholder: "Package",
                modelValue: appointment.value.package_name,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((appointment.value.package_name) = $event)),
                id: "package_name",
                name: "package_name"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(TextInput, {
                disabled: "",
                label: "Rider/s",
                placeholder: "Rider/s",
                modelValue: riders.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((riders).value = $event)),
                id: "riders",
                name: "riders"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(TextInput, {
                disabled: "",
                "add-on-left": "",
                "add-on-text": "₱",
                label: "Package Fee",
                placeholder: "Package Fee",
                modelValue: appointment.value.package_fee,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((appointment.value.package_fee) = $event)),
                id: "package_fee",
                name: "package_fee"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(TextInput, {
                disabled: "",
                "add-on-left": "",
                "add-on-text": "₱",
                label: "Miscellaneous Fee",
                placeholder: "Miscellaneous Fee",
                modelValue: appointment.value.other_charges_fee,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((appointment.value.other_charges_fee) = $event)),
                id: "other_charges_fee",
                name: "other_charges_fee"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(TextInput, {
                disabled: "",
                "add-on-left": "",
                "add-on-text": "₱",
                label: "Total Fee",
                placeholder: "Total Fee",
                modelValue: appointment.value.total_fee,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((appointment.value.total_fee) = $event)),
                id: "total_fee",
                name: "total_fee"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(TextInput, {
                disabled: "",
                label: "Booking Type",
                placeholder: "Booking Type",
                modelValue: appointment.value.booking_type,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((appointment.value.booking_type) = $event)),
                id: "booking_type",
                name: "booking_type"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 2
        }, [
          (props.isNetworkAvailable)
            ? {
                name: "actions",
                fn: _withCtx(() => [
                  (_ctx.$hasPermission('soft-book-dates-for-individual-patient'))
                    ? (_openBlock(), _createBlock(ButtonComponent, {
                        key: 0,
                        disabled: loader.value,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (showConfirmation.value = true))
                      }, {
                        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                          _createTextVNode(" Update ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "default")
                ]),
                key: "0"
              }
            : undefined
        ]), 1024))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(ErrorModal, {
      width: "w-[548px]",
      title: "Error",
      "action-text": "Close",
      "cancel-text": "Go back",
      show: showError.value,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (showError.value = false)),
      onConfirm: _cache[16] || (_cache[16] = ($event: any) => (showError.value = false)),
      errors: errors.value
    }, {
      content: _withCtx(() => [
        _createTextVNode(_toDisplayString(errorMsg.value), 1)
      ]),
      _: 1
    }, 8, ["show", "errors"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onCancel: _cache[17] || (_cache[17] = ($event: any) => (showSuccess.value = false)),
      onConfirm: _cache[18] || (_cache[18] = ($event: any) => (showSuccess.value = false)),
      "action-text": "Confirm",
      title: "Booking Submitted!",
      content: "Booking has been updated successfully"
    }, null, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      show: showConfirmation.value,
      onCancel: _cache[19] || (_cache[19] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[20] || (_cache[20] = ($event: any) => {showConfirmation.value = false; updateSoftBooking() }),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Submit Booking?",
      content: "Are you sure you wish to update this booking?"
    }, null, 8, ["show"])
  ], 64))
}
}

})